import { IncidentDto, UomDto } from '@cradua/data';
import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,

  } from '@angular/core';
import Swal from 'sweetalert2';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'cradua-incident-list',
    templateUrl: './incident-list.component.html',
    styleUrls: ['./incident-list.component.scss'],
  })
export class IncidentListComponent implements OnInit{

    @Input() incident: IncidentDto[];
    @Input() uoms: UomDto[];
    @Output() emitEvent = new EventEmitter<any>();
    @Output() dispatchView = new EventEmitter<any>();
    @Output() dispatchViewList = new EventEmitter<any>();
    @Output() dispatchDelete = new EventEmitter<string>();
    @Output() searchEmit = new EventEmitter<any>();

    incidentType = '';
    incidentClone = [];
    isViewRange = false;
    listView = false;
    gridView = true;

    rangeForm = new FormGroup({
      StartDate: new FormControl(null),
      EndDate: new FormControl(null),
    })

    constructor() {}

    ngOnInit(){
     this.incidentClone = this.incident;
    }

    onViewRange() {
      this.isViewRange = !this.isViewRange;
    }

    onSearch() {
      if(!this.rangeForm.value.StartDate && !this.rangeForm.value.EndDate) return;
      this.searchEmit.emit({name: 'range', ...this.rangeForm.value})
    }
    onList() {
      this.listView = true;
      this.gridView = false;
    }

    onGrid() {
      this.gridView = true;
      this.listView = false;
    }

       onView(value){
          this.dispatchView.emit(value);
      }

      getUOMName(id: string) {
        return this.uoms.find(uom => uom.id === id)?.UomName || null;
      }


      deleteIncident(id: string) {
              Swal.fire({
                  title: 'Are you sure?',
                  text: 'You will not be able to recover this imaginary file!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete it!',
                  cancelButtonText: 'No, keep it'
                }).then((result) => {
                  if (result.value) {
                    this.dispatchDelete.emit(id);
              Swal.fire(
                      'Deleted!',
                      'Your imaginary file has been deleted.',
                      'success'
                    );
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                      Swal.fire(
                        'Cancelled',
                        'Your imaginary file is safe :)',
                        'error'
                      );
                    }
                  });

      }
}
